import Form from '../../layouts/Form';
import CourierOrderForm from "./CourierOrderForm";
import LogisticOrderForm from "./LogisticOrderForm";
import Modal from '../Reusable/Modal';
import CreateCustomer from './CreateCustomerForm';
import { useForm, useFieldArray } from "react-hook-form";
import Button from '../Reusable/Button';
import { toast } from 'react-toastify';
import { useHotkeys } from 'react-hotkeys-hook';
import APIS from '../../constant/EndPoint';
import { useNavigate } from "react-router-dom";
const EditOrder = (props: any) => {
  const navigate = useNavigate();
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    watch,
    reset,
    getValues,
    clearErrors
  } = useForm<any>({
    defaultValues: async () => {
      let order = props?.order
      return {
        pickup_branch: order.pickup_branch,
        destination: order?.destination,
        vendor: order?.merchant,
        sender: order?.sender,
        receiver: order?.receiver,
        service_type: order?.service_type,
        payment_method: order?.payment_method,
        reference_type: order?.reference_type,
        reference_date: order?.reference_date,
        reference_number: order?.reference_number,
        order_value: order?.order_value,
        cod: order?.cod,
        note: order?.note,
        delivery_charge: order?.delivery_charge,
        order_items: order?.children?.map((item: any, index: number) => ({
          package_type: { ...item.package_type },
          piece: item?.piece,
          weight: item?.weight
        }))
      }
    }
  });
  const { handleEdit,
    isLoading,
    handleCreateCustomer,
    createCustomerLoading,
    setOpenAddReceiverPopup,
    openAddReceiverPopup,
    openAddSenderPopup,
    setOpenAddSenderPopup,
    openPrintPopup,
    setOpenPrintPopup,
    profile,
    handleLabelPrintDownload,
    handleOrderReceiptDownload,
    isPrintLoading,
    clientType,
    calculateDeliveryCharge
  } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "order_items"
  });


  const handleSetDeliveryCharge = async () => {
    const url = `${APIS.ORDER}get-delivery-charge/`;
    let formData = {
      form_data: getValues()
    };
    try {
      const res = await calculateDeliveryCharge({ url, formData });
      if (res.status === 200) {
        setValue("delivery_charge", res?.data?.charge)
      } else {
        toast.error("Delivery charge not found")
      }
    } catch (err) {
      console.log(err);
    }
  }
  useHotkeys('f1', () => {
    if (!getValues()["destination"]) {
      toast.error("Destination is missing")
      return
    }
    if (!getValues()["service_type"]) {
      toast.error("Service Type is missing")
      return
    }
    if (!getValues()["payment_method"]) {
      toast.error("Payment method is missing")
      return
    }
    let orderItems = getValues()["order_items"].filter((item) => item.package_type !== null)
    if (!orderItems.length) {
      toast.error("Sub order is missing")
      return
    }
    handleSetDeliveryCharge()
  })

  const handleClosePrintPopup = () => {
    setOpenPrintPopup(false)
    navigate("/order?limit=10&page=0")
  }

  return (
    <>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >{clientType?.type === "logistic" ?
        <LogisticOrderForm
          profile={profile}
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          fields={fields}
          append={append}
          remove={remove}
          handleSetDeliveryCharge={handleSetDeliveryCharge}
        /> : <CourierOrderForm
          profile={profile}
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          fields={fields}
          append={append}
          remove={remove}
        />}
      </Form>
      <Modal
        isOpen={openAddReceiverPopup}
        setIsOpen={setOpenAddReceiverPopup}
        title={"Craeate Receiver"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />
      <Modal
        isOpen={openAddSenderPopup}
        setIsOpen={setOpenAddSenderPopup}
        title={"Create Sender"}
        children={<>
          <CreateCustomer
            handleCreate={handleCreateCustomer}
            isLoading={createCustomerLoading}
          />
        </>} />

      <Modal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrintPopup}
        title={"Print "}
        children={<div>
          <Button label={"Print Label"} isLoading={isPrintLoading} disabled={isPrintLoading} onClick={handleLabelPrintDownload} />
          <Button label={"Print Receipt"} isLoading={isPrintLoading} disabled={isPrintLoading} onClick={handleOrderReceiptDownload} />
        </div>} />
    </>


  )
}

export default EditOrder
